import dynamic from 'next/dynamic'

export const BentoBox = dynamic(() => import('./bento-box'))
